/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/JsmWorkItemIssueDetailsQuery$parameters.ts';
import type { JsmWorkItemIssueDetailsQuery } from './__generated__/JsmWorkItemIssueDetailsQuery.graphql.ts';

type JsmWorkItemEntryPointComponent = EntryPointComponent<
	{
		issueDetailsQuery: JsmWorkItemIssueDetailsQuery;
	},
	{},
	{},
	{
		context: EntryPointRouteParams['context'];
	}
>;

export const jsmWorkItemEntryPoint: EntryPoint<
	JsmWorkItemEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<JsmWorkItemEntryPointComponent>(
		/* webpackChunkName: "async-jsm-work-item" */ './JsmWorkItem.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => {
		const issueKey = context.match?.params?.issueKey || context.query?.selectedIssue || '';
		const cloudId = tenantContext.cloudId;

		return {
			queries: {
				issueDetailsQuery: {
					parameters,
					variables: {
						issueKey: issueKey || '',
						cloudId: cloudId || '',
					},
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
			extraProps: { context },
		};
	},
});
